import { memo, useEffect, useRef } from "react";
import { ArrowLeft } from "lucide-react";

const Spark = ({ value }) => {
  const ref = useRef(null), buf = useRef([]);
  useEffect(() => {
    const b = buf.current; b.push(value || 0); if (b.length > 60) b.shift();
    const c = ref.current; if (!c) return; const g = c.getContext("2d"), w = c.width, h = c.height, mx = Math.max(0.001, ...b);
    g.clearRect(0, 0, w, h); g.strokeStyle = "#00F0FF"; g.lineWidth = 1.5; g.beginPath();
    b.forEach((v, i) => { const x = (i / 59) * w, y = h - (v / mx) * (h - 3) - 1; i ? g.lineTo(x, y) : g.moveTo(x, y); }); g.stroke();
    g.lineTo(w, h); g.lineTo(0, h); g.fillStyle = "rgba(0,240,255,0.08)"; g.fill();
  }, [value]);
  return <canvas ref={ref} width={110} height={28} className="w-[110px] h-7" data-testid="hud-energy-sparkline" />;
};

export const Stat = ({ label, value, testid, accent }) => (
  <div className="hud-stat" data-testid={testid}>
    <span className="hud-stat-label">{label}</span>
    <span className={`hud-stat-value ${accent ? "text-[#FFB800]" : ""}`}>{value}</span>
  </div>
);

export const HudBrand = ({ ins, onLab }) => (
  <div className="flex items-center gap-3 min-w-0">
    <button className="lab-return" onClick={onLab} data-testid="button-return-lab" title="Return to Laboratory"><ArrowLeft size={15} /><span>Laboratory</span></button>
    <div className="cube-wrap" data-testid="hud-logo"><div className="cube"><i /><i /><i /><i /><i /><i /><b /></div></div>
    <div className="min-w-0">
      <div className="hud-kicker hidden sm:block">DIGITAL MATTER LAB <em>//</em> {ins.code}</div>
      <h1 className="hud-title holo-text" data-testid="hud-mode-name">{ins.name}</h1>
    </div>
  </div>
);

export const TopHud = memo(function TopHud({ ins, tel, settings, view, onLab }) {
  return (
    <header className="hud-top" data-testid="top-hud">
      <HudBrand ins={ins} onLab={onLab} />
      <div className="hidden xl:flex items-center gap-2 flex-nowrap overflow-hidden min-w-0 justify-center" data-testid="hud-mode-telemetry">
        {(tel?.items || []).slice(0, 5).map(([k, v], i) => <Stat key={k} label={k} value={v} testid={`hud-tel-${i}`} />)}
      </div>
      <div className="flex items-center gap-2">
        <Stat label="FPS" value={tel?.fps ?? "—"} testid="hud-fps" accent={tel && tel.fps < 30} />
        <div className="hidden md:flex"><Stat label={ins.style === "pins" ? "Pins" : "Nodes"} value={tel ? tel.pins.toLocaleString() : "—"} testid="hud-pin-count" /></div>
        <div className="hidden lg:block">
          <div className="hud-stat hud-stat-row">
            <div className="flex flex-col"><span className="hud-stat-label">Kinetic</span><span className="hud-stat-value" data-testid="hud-kinetic">{tel ? tel.energy.toFixed(2) : "—"}</span></div>
            <Spark value={tel?.energy} />
          </div>
        </div>
        <div className={`hud-badge ${settings.paused ? "is-paused" : ""}`} data-testid="hud-sim-status">{settings.paused ? "PAUSED" : "LIVE"}</div>
        <div className="hidden xl:block hud-badge plain" data-testid="hud-camera-view">{view}</div>
      </div>
    </header>
  );
});
